import axios from 'axios'
import { transformSelectedSetup } from '../api/utils'

const API_URL = `${process.env.REACT_APP_API_URL}`

const PowerCurve = {
  getPowerCurveData(setup, plant) {
    return axios({
      method: 'get',
      url: `${API_URL}/power_curves`,
      params: {
        setup_name: transformSelectedSetup(setup),
        plant_id: plant,
      },
    })
    // Mock toggle — comment out the call above and use one of these to test
    // each type without the backend:
    // return axios.get('/mock/wind_power_curves_EPZ.json')
    // return axios.get('/mock/solar_power_curves_Zonnepark_EPZ.json')
  },
}

export default PowerCurve
